import { logConsoleError } from '@core/utils/logger'
import { reactErrorHandler } from '@sentry/react'
import { isNotFound, isRedirect } from '@tanstack/react-router'
import type { ErrorInfo } from 'react'

const captureRenderError = reactErrorHandler(logConsoleError)

function reportRenderError(error: unknown, errorInfo: ErrorInfo) {
  if (isNotFound(error) || isRedirect(error)) return
  captureRenderError(error, errorInfo)
}

export const rootErrorHandlers = {
  onCaughtError: reportRenderError,
  onUncaughtError: reportRenderError,
  onRecoverableError: reportRenderError,
}
